var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 300H700M233.333 100V166.667M566.667 100V166.667M200 433.333H266.667M200 566.667H266.667M366.667 433.333H433.333M366.667 566.667H433.333M533.333 433.333H600M533.333 566.667H600M206.667 700H593.333C630.67 700 649.34 700 663.6 692.733C676.143 686.343 686.343 676.143 692.733 663.6C700 649.34 700 630.67 700 593.333V273.333C700 235.996 700 217.328 692.733 203.067C686.343 190.523 676.143 180.324 663.6 173.933C649.34 166.667 630.67 166.667 593.333 166.667H206.667C169.33 166.667 150.661 166.667 136.401 173.933C123.856 180.324 113.658 190.523 107.266 203.067C100 217.328 100 235.996 100 273.333V593.333C100 630.67 100 649.34 107.266 663.6C113.658 676.143 123.856 686.343 136.401 692.733C150.661 700 169.33 700 206.667 700Z",
    stroke: "white",
    strokeWidth: 66.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e35108dae0c4ad782dcc4a817f99f47e.svg";
export { ForwardRef as ReactComponent };